const lv = (v: string) => ({ label: v, value: v })

export const spheresOfExpertise: [string, string[]][] = [
  ['Клиническая медицина', [
    'Рентгенэндоваскулярная хирургия',
    'Челюстно-лицевая хирургия',
    'Оториноларингология',
    'Акушерство и гинекология',
    'Офтальмология',
    'Онкология, лучевая терапия',
    'Стоматология',
    'Травматология и ортопедия',
    'Хирургия',
    'Нейрохирургия',
    'Детская хирургия',
    'Анестезиология и реаниматология',
    'Урология и андрология',
    'Трансплантология и искусственные органы',
    'Сердечно-сосудистая хирургия',
    'Пластическая хирургия',
    'Психиатрия и наркология',
    'Внутренние болезни',
    'Эндокринология',
    'Кардиология',
    'Педиатрия',
    'Инфекционные болезни',
    'Дерматовенерология',
    'Неврология',
    'Лучевая диагностика',
    'Фтизиатрия',
    'Ревматология',
    'Гематология и переливание крови',
    'Пульмонология',
    'Гастроэнтерология и диетология',
    'Геронтология и гериатрия',
    'Нефрология',
    'Восстановительная медицина',
    'Спортивная медицина',
    'Лечебная физкультура',
    'Курортология',
    'Физиотерапия',
  ]],
  ['Профилактическая медицина', [
    'Гигиена',
    'Эпидемиология',
    'Общественное здоровье',
    'Организация здравоохранения',
    'Социология',
    'История медицины',
    'Медицина труда',
    'Медицинская психология',
    'Безопасность в чрезвычайных ситуациях',
    'Аллергология и иммунология',
  ]],
  ['Первичная медико-санитарная помощь', ['Первичная медико-санитарная помощь']],
  ['Детские болезни', ['Детские болезни']],
]

export const spheresOfExpertiseOptions = [
  {
    label: 'Клиническая медицина',
    options: [
      lv('Рентгенэндоваскулярная хирургия'),
      lv('Челюстно-лицевая хирургия'),
      lv('Оториноларингология'),
      lv('Акушерство и гинекология'),
      lv('Офтальмология'),
      lv('Онкология, лучевая терапия'),
      lv('Стоматология'),
      lv('Травматология и ортопедия'),
      lv('Хирургия'),
      lv('Нейрохирургия'),
      lv('Детская хирургия'),
      lv('Анестезиология и реаниматология'),
      lv('Урология и андрология'),
      lv('Трансплантология и искусственные органы'),
      lv('Сердечно-сосудистая хирургия'),
      lv('Пластическая хирургия'),
      lv('Психиатрия и наркология'),
      lv('Внутренние болезни'),
      lv('Эндокринология'),
      lv('Кардиология'),
      lv('Педиатрия'),
      lv('Инфекционные болезни'),
      lv('Дерматовенерология'),
      lv('Неврология'),
      lv('Лучевая диагностика'),
      lv('Фтизиатрия'),
      lv('Ревматология'),
      lv('Гематология и переливание крови'),
      lv('Пульмонология'),
      lv('Гастроэнтерология и диетология'),
      lv('Геронтология и гериатрия'),
      lv('Нефрология'),
      lv('Восстановительная медицина'),
      lv('Спортивная медицина'),
      lv('Лечебная физкультура'),
      lv('Курортология'),
      lv('Физиотерапия'),
    ]
  },
  {
    label: 'Профилактическая медицина',
    options: [
      lv('Гигиена'),
      lv('Эпидемиология'),
      lv('Общественное здоровье'),
      lv('Организация здравоохранения'),
      lv('Социология'),
      lv('История медицины'),
      lv('Медицина труда'),
      lv('Медицинская психология'),
      lv('Безопасность в чрезвычайных ситуациях'),
      lv('Аллергология и иммунология'),
    ]
  },
  {
    label: 'Первичная медико-санитарная помощь', options: [
      lv('Первичная медико-санитарная помощь'),
    ]
  },
  {
    label: 'Детские болезни', options: [
      lv('Детские болезни'),
    ]
  },
]

const tdtk = (name: string) => ({ title: name, value: name, key: name })

export const spheresOfExpertiseTreeData = [
  {
    ...tdtk('Клиническая медицина'),
    selectable: false,
    children: [
      {
        ...tdtk('Терапия'),
        selectable: false,
        children: [
          tdtk('Акушерство и гинекология'),
          tdtk('Аллергология и иммунология'),
          tdtk('Анестезиология и реаниматология'),
          tdtk('Восстановительная медицина, спортивная медицина, лечебная физкультура, курортология и физиотерапия'),
          tdtk('Гастроэнтерология и диетология'),
          tdtk('Гематология и переливание крови'),
          tdtk('Геронтология и гериатрия'),
          tdtk('Дерматовенерология'),
          tdtk('Инфекционные болезни'),
          tdtk('Кардиология'),
          tdtk('Медицинская психология'),
          tdtk('Неврология'),
          tdtk('Нефрология'),
          tdtk('Оториноларингология'),
          tdtk('Офтальмология'),
          tdtk('Онкология, лучевая терапия'),
          tdtk('Психиатрия и наркология'),
          tdtk('Пульмонология'),
          tdtk('Ревматология'),
          tdtk('Стоматология'),
          tdtk('Урология и андрология'),
          tdtk('Фтизиатрия'),
          tdtk('Эндокринология'),
        ]
      },
      {
        ...tdtk('Хирургия'),
        selectable: false,
        children: [
          tdtk('Нейрохирургия'),
          tdtk('Пластическая хирургия'),
          tdtk('Рентгенэндоваскулярная хирургия'),
          tdtk('Сердечно-сосудистая хирургия'),
          tdtk('Травматология и ортопедия'),
          tdtk('Трансплантология и искусственные органы'),
          tdtk('Челюстно-лицевая хирургия'),
        ]
      }
    ]
  },
  tdtk('Методы исследования и диагностики'),
  tdtk('Профилактическая медицина'),
  tdtk('Общественное здоровье и организация здравоохранения, социология и история медицины'),
  tdtk('Первичная медико-санитарная помощь'),
  tdtk('Гигиена'),
  tdtk('Эпидемиология'),
  tdtk('Медицина труда'),
  tdtk('Безопасность в чрезвычайных ситуациях'),
]
